import * as React from 'react';

import useRouter from 'js/lib/useRouter';

import PagePlaceholder from 'bundles/unified-description-page-common/components/shared/PagePlaceholder';
import { usePortfolioProject } from 'bundles/unified-description-page-common/contexts/PortfolioProjectCheckContext';
import {
  useEnterpriseCoursePageData,
  useEnterpriseCoursePageError,
  useIsEnterpriseCourseDataLoading,
} from 'bundles/unified-description-page-common/contexts/enterprise/EnterpriseBffCourseContext';
import {
  useEnterpriseS12nPageError,
  useEnterpriseSpecializationPageData,
  useIsEnterpriseS12nDataLoading,
} from 'bundles/unified-description-page-common/contexts/enterprise/EnterpriseBffSpecializationContext';
import useClientSideRouteCheck from 'bundles/unified-description-page-common/hooks/useClientSideRouteCheck';
import EnterprisePageDataErrorHandler from 'bundles/unified-description-page-common/pages/enterprise/EnterprisePageDataErrorHandler';

type Props = {
  children: React.ReactNode;
};

// Ensure all conditions pass in order to show enterprise description page
const EnterprisePageGuard = ({ children }: Props) => {
  useClientSideRouteCheck();
  const s12nData = useEnterpriseSpecializationPageData();
  const router = useRouter();
  const courseData = useEnterpriseCoursePageData();
  const isCourseDataLoading = useIsEnterpriseCourseDataLoading();
  const isS12nDataLoading = useIsEnterpriseS12nDataLoading();
  const courseDataError = useEnterpriseCoursePageError();
  const s12nDataError = useEnterpriseS12nPageError();
  const { isLoadingPortfolioProject } = usePortfolioProject();

  if (isCourseDataLoading || isS12nDataLoading || isLoadingPortfolioProject) {
    return <PagePlaceholder />;
  } else if (!courseData && !s12nData) {
    return (
      <EnterprisePageDataErrorHandler pathname={router.location.pathname} error={courseDataError || s12nDataError} />
    );
  } else {
    return <React.Fragment>{children}</React.Fragment>;
  }
};

export default EnterprisePageGuard;
